<template>
  <span>
    <img draggable="false" @click="goToHome()" id="top_quit_btn" src="./../assets/images/Asset 3.png" alt="">

    <span v-show="$store.getters['app/overlays'].show_game_overlay">
      <img draggable="false" id="gezond_lichaam_img_2" src="./../assets/images/Asset 2.png" alt="">
      <img draggable="false" id="person_img_2" src="./../assets/images/Asset 1.png" alt="">

      <div class="game_container">
        <span id="text_title">Hoe speel je dit?</span>
        <span id="text_description">Sleep een klontje suiker op het product tot je de juiste hoeveelheid gram hebt bereikt en dat zie je als het balkje onder elk product, groen wordt.</span>
        <img draggable="false" id="klontje_1" src="./../assets/images/Asset 21.png" alt="">
        <img draggable="false" id="klontje_2" src="./../assets/images/Asset 22.png" alt="">
        <img draggable="false" id="klontje_3" src="./../assets/images/Asset 23.png" alt="">
        <img draggable="false" id="klontje_4" src="./../assets/images/Asset 24.png" alt="">
        <img draggable="false" id="klontje_5" src="./../assets/images/Asset 25.png" alt="">
        <span id="text_description_2">Elk suiker klontje bevat 5 gram suiker.</span>
        <img draggable="false" @click="goToGamePage()" id="start_btn_2" src="./../assets/images/Asset 4.png" alt="">
      </div>
    </span>
  </span>
</template>

<script>


export default {
  name: "Start",
  mounted() {},

  created() {},
  destroyed() {},

  data() {
    return {};
  },

  methods: {
    goToHome() {
      this.$router.push('/');
      this.$store.dispatch('app/asyncUpdateOverlay', {
          show_start_menu_overlay: true,
          show_start_selector_overlay: false,
      });
    },
    goToGamePage() {
      this.$router.push('/game');
    },
  },

  computed: {}
};
</script>

<style>
  #text_title {
    width: 70%;
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 2%;
    left: 18%;
    color: #69a643;
    font-size: 4vw;
    text-align: center;
  }

  #text_description {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 12%;
    left: 19%;
    color: #69a643;
    font-size: 1.5vw;
    width: 63%;
    text-align: center;
  }

  #text_description_2 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 38%;
    left: 22%;
    color: #69a643;
    font-size: 1.4vw;
    width: 58%;
    text-align: center
  }

  #top_quit_btn {
    cursor: url('./../assets/cursor/material-wood-pointer.png'), default;	
    position: absolute;
    margin-top: 2%;
    right: 2%;
    width: 15%;
  }

  #top_quit_btn:hover {
    opacity: 0.7;
  }

  #gezond_lichaam_img_2 {
    position: absolute;
    top: 2%;
    left: 23%;
    width: 25%;
    height: auto;
  }

  #person_img_2 {
    position: absolute;
    top: 28%;
    right: 15%;
    width: 15%;
    height: auto;
  }

  .game_container {
    width: 58%;
    height: 62%;
    position: absolute;
    background-color: #fcce07;
    left: 5%;
    top: 30%;
    border-radius: 35px;
    border-style: solid;
    border-color: #fefefe;
    border-width: 8px;
    -webkit-filter: drop-shadow(5px 5px 5px #464646);
    filter: drop-shadow(5px 5px 5px #464646);
  }

  #klontje_1 {
    position: absolute;
    left: 25%;
    margin-top: 26%;
    width: 10%;
  }
  #klontje_2 {
    position: absolute;
    left: 36%;
    margin-top: 26%;
    width: 10%;
  }
  #klontje_3 {
    position: absolute;
    left: 47%;
    margin-top: 26%;
    width: 10%;
  }
  #klontje_4 {
    position: absolute;
    left: 57%;
    margin-top: 26%;
    width: 10%;
  }
  #klontje_5 {
    position: absolute;
    left: 68%;
    margin-top: 26%;
    width: 10%;
  }
  #start_btn_2 {
    position: absolute;
    width: 15%;
    left: 45%;
    bottom: 5%;
  }

  #start_btn_2:hover {
    cursor: url('./../assets/cursor/material-wood-pointer.png'), default;	
    opacity: 0.7;
  }
</style>


